/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import i18n from "../../plugins/locale/i18n";
import loadDictionary from "../../plugins/locale/load-dictionary";
import PartyService from "../../service/party-service";

const partyService = new PartyService();

await loadDictionary('party-edit-window');

function EditPartyWindow ({isOpenWindow, onCloseWindow, selectedPartyId}) {
  const [id, setId] = useState(0);
  const [name, setName] = useState('');
  const [accountingNumber, setAccountingNumber] = useState('');
  
  const handleClose = () => {
    setId(0);
    setName('');
    setAccountingNumber('');
    onCloseWindow();
  };
  
  const handleSubmit = () => {
    const party = {
      id: parseInt(id),
      name: name,
      accounting_number: accountingNumber
    };

    partyService.edit(party).then(result => {
      if(result) {
        handleClose();
      }
    }).catch(error => {
      console.error(error);
    });
  }

  useEffect(() => {
    if(selectedPartyId) {
      partyService.findOne(selectedPartyId).then(party => {
        if(party) {
          setId(party.id);
          setName(party.name);
          setAccountingNumber(party.accounting_number);
        }
      });
    }
  }, [selectedPartyId]);

  return (
    <Modal show={isOpenWindow} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>{i18n.t("party-edit-window.title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form method="POST" id="EditForm" onSubmit={e => {e.preventDefault(); handleSubmit()}}>
          <Form.Group className="mb-3" controlId="">
            <Form.Label>{i18n.t("party-edit-window.name")}</Form.Label>
            <Form.Control type="text" autoFocus value={name} onChange={e => {setName(e.target.value)}}></Form.Control>
          </Form.Group>
          <Form.Group className="mb-3" controlId="">
            <Form.Label>{i18n.t("party-edit-window.accounting_number")}</Form.Label>
            <Form.Control type="text" dir="ltr" value={accountingNumber} onChange={e => {setAccountingNumber(e.target.value)}}></Form.Control>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>{i18n.t("party-edit-window.cancel_button")}</Button>
        <Button variant="primary" type="submit" form="EditForm" >{i18n.t("party-edit-window.edit_button")}</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default EditPartyWindow;